import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Environment } from "app/decorators/environment.decorator";
import { SnackBarService } from "cw-utils";
import { ApiGateway } from "../../../api-gateway";

@Injectable({
    providedIn: "root",
})
export class BondService {

    @Environment("baseUrl") baseUrl: string;

    constructor(public gw: ApiGateway, public snackBar: SnackBarService, private httpClient: HttpClient) { }

    insertBondPayAccountsPayable(bondPay): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`bond/accounts-payable/bond-pay/`, bondPay).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    insertBondPayAccountsReceivable(bondPay): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`bond/accounts-receivable/bond-pay/`, bondPay)
                .subscribe({
                    next: (response: HttpResponse<any>) => {
                        resolve(response);
                        this.snackBar.successMessage(response.body.message);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }


    insertBondPayByOfx(bondPayList, eartefactId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`bond/ofx/bond-pay/${eartefactId}`, bondPayList)
                .subscribe({
                    next: (response: HttpResponse<any>) => {
                        resolve(response);
                        this.snackBar.successMessage(response.body.message);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    copyBondRecurrent(originDate, destinationDate, type, moreMonth): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`bond/copy-bond-recurrent?originDate=${originDate}&destinationDate=${destinationDate}&type=${type}&moreMonth=${moreMonth}`).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    deleteBondPayIdAccountsPayable(bondPayId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .delete(`bond/accounts-payable/bond-pay/${bondPayId}`)
                .subscribe({
                    next: (response: HttpResponse<any>) => {
                        resolve(response);

                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }
    deleteBondPayIdAccountsReceivable(bondPayId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .delete(`bond/accounts-receivable/bond-pay/${bondPayId}`)
                .subscribe({
                    next: (response: HttpResponse<any>) => {
                        resolve(response);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    findByTotalPay(bondId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get(`bond/total-pay/${bondId}`).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    checkAdjustments(bondId, date) {
        let params: string = "";
        params += `?date=${date}`;
        params += `&bondId=${bondId}`;
        return new Promise<any>((resolve, reject) => {
            this.gw.get(`bond/bond-pay/check-adjustments/${params}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    findBondDetailByBondId(bondId) {
        return new Promise<any>((resolve, reject) => {
            this.gw.get(`bond/${bondId}/bond-detail`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getBondPayByBondId(bondId, pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw
                .post(`bond/bond/${bondId}/bond-pay`, pageOptions)
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    getBondTotal(bondIdList) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post(`bond/total`, bondIdList).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getBondPayById(bondPayId) {
        return new Promise<any>((resolve, reject) => {
            this.gw.get(`bond/bond-pay/${bondPayId}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPageCompany(pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post("bond/company", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getCompanyCostCenterByCompanyId(companyId: number) {
        return new Promise<any>((resolve, reject) => {
            this.gw
                .get(`bond/company-cost-center/company/${companyId}`)
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    getPageSupplier(pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post("bond/supplier", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPageInsurance(pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post("bond/insurance", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPageFirm(pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post("bond/firm", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPagePatient(pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post("bond/patient", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPagePerformer(pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post("bond/performer", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPagePerson(pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post("bond/person", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPageProfessional(pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post("bond/professional", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPageUser(pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post("bond/user", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getHistoric(pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post("bond/historic", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getDocType(pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post("bond/doc-type", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getAccountByCompanyId(companyId, pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw
                .post(`bond/account/company/${companyId}`, pageOptions)
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    getAccount(pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post(`bond/account`, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getDafaultValues() {
        return new Promise<any>((resolve, reject) => {
            this.gw.get(`bond/default-values`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPayType(pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post(`bond/pay-type`, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPageCompanyAccountPlanByCompanyAndType(companyId, type, pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw
                .post(
                    `bond/company-account-plan/company/${companyId}/type/${type}`,
                    pageOptions
                )
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    getPageAccountByType(applyFilter) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post(`bond/type`, applyFilter).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getBondEartefact(bondId: number) {
        return new Promise<any>((resolve, reject) => {
            this.gw.get(`bond/bond-eartefact/${bondId}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getContentEartefact(eartefactId: number) {
        return new Promise<any>((resolve, reject) => {
            this.gw.get(`bond/bond-eartefact/eartefact/${eartefactId}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    importEartefact(file: File, bondId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            const endpoint = this.baseUrl + 'bond/bond-eartefact/' + bondId;
            const formData: FormData = new FormData();
            formData.append('file', file, file.name);

            const authToken: string = localStorage.getItem('token') || '';
            let headers = new HttpHeaders();
            if (authToken) {
                headers = headers.append('X-Auth-Token', authToken);
            }

            this.httpClient
                .post(endpoint, formData, { headers: headers })
                .subscribe({
                    next: (res) => {
                        resolve(res);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }

    updateCompanyCostCenter(bondId: number, companyAccountPlanId: number, historicId: number, note: string) {
        let params: string = "";
        params += `?bondId=${bondId}`;
        params += `&companyAccountPlanId=${companyAccountPlanId}`;
        if (historicId) {
            params += `&historicId=${historicId}`;
        }
        if (note) {
            params += `&note=${note}`;
        }
        return new Promise<any>((resolve, reject) => {
            this.gw.put(`bond/update/company-account-plan${params}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getApportionmentByCompanyAndAccountPlanId(companyId: number, accountPlanId: number) {

        return new Promise<any>((resolve, reject) => {
            this.gw.get(`bond/apportionment?companyId=${companyId}&accountPlanId=${accountPlanId}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    deleteBondApportionment(bondId: number) {
        return new Promise<any>((resolve, reject) => {
            this.gw.delete(`bond/apportionment/${bondId}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }
}
